import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	accountName: {
		...THEME.common.truncate,
		opacity: 0.85,
	},
	action: {
		backgroundColor: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.dark}`,
		color: THEME.colors.warning.contrastText,
		flexShrink: 0,
		fontWeight: THEME.typography.fontWeights.semibold,
		':hover': {
			backgroundColor: THEME.colors.warning.light,
			borderColor: THEME.colors.warning.dark,
		},
	},
	container: {
		alignItems: 'center',
		backgroundColor: THEME.colors.warning.main,
		boxSizing: 'border-box',
		color: THEME.colors.warning.contrastText,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.md,
		justifyContent: 'space-between',
		lineHeight: 1.4,
		minHeight: 52,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.lg}px`,
		width: '100%',
	},
	fixed: {
		left: 0,
		position: 'fixed',
		right: 0,
		top: 0,
		zIndex: 1000,
	},
	icon: {
		flexShrink: 0,
	},
	message: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	messageGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.md,
		minWidth: 0,
	},
	separator: {
		opacity: 0.75,
	},
	strong: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
});
